module.exports = __webpack_public_path__ + "04_long_gold.c70f813a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_long_gold.png
// module id = TMBL
// module chunks = 0